$(document).ready(function () {
    $('br').attr('aria-hidden','true'); 
    $('hr').attr('aria-hidden','true');

    $('a#back-to-top').on('click', function(e) {
      e.preventDefault();
      setTimeout(() => {
      $('#back-btn').focus();      
      }, 500);
    }); 

})

// empty Headings
$(document).ready(function() {
    $('h1, h2, h3, h4, h5, h6').filter(function() {
      return $(this).text().replace(/\s+/g, '') === '' &&  $(this).children().length === 0;
    }).remove();
});

// Email Label to all Email Address
$(document).ready(function() {
  $('a[href^="mailto:"]').each(function() {
    const $link = $(this);
    const title = ($link.attr('title') || '').trim();
    const existingLabel = ($link.attr('aria-label') || '').trim();

    // Do not overwrite an existing aria-label
    if (existingLabel) {
      return;
    }

    // Extract email from mailto
    let email = $link.attr('href').replace(/^mailto:/i, '').trim();

    email = decodeURIComponent(email)
      .split('?')[0]
      .split('&')[0];

    // Use title first, otherwise email
    let labelText = title || email;

    // Remove existing "Email Address:" prefix if present
    labelText = labelText.replace(/^Email Address:\s*/i, '');

    if (labelText) {
      $link.attr('aria-label', `Email Address: ${labelText}`);
    }
  });
});

// Phone Label to all Phone Number
$(document).ready(function() {
  $('a[href^="tel:"]').each(function() {
    const $link = $(this);
    const title = ($link.attr('title') || '').trim();
    const visibleText = $link.text().trim();
    const existingLabel = ($link.attr('aria-label') || '').trim();

    // Do not overwrite an existing aria-label
    if (existingLabel) {
      return;
    }

    // Use title first, otherwise visible text
    let labelText = title || visibleText;

    // Remove existing "Phone Number:" prefix if present
    labelText = labelText.replace(/^Phone Number:\s*/i, '');

    if (labelText) {
      $link.attr('aria-label', `Phone Number: ${labelText}`);
    }
  });
});

// adding label to the links
// $(document).ready(function() {
  
//   var $button = $('a.button.button--primary[href="/collections/premiere-stainless-collection"]');
  
//   // Apply the label
//   $button.attr('aria-label', 'Shop the Premiere Stainless Collection');

//   var $learnMoreLink = $('a.button[href="/pages/certified-refurbished-1"]');
  
//   // Apply a descriptive aria-label to give context to screen readers
//   $learnMoreLink.attr('aria-label', 'Learn more about our certified refurbished products');

// });



// Social and External link warning Fixed
$(document).ready(function() {
    const currentHost = window.location.hostname.replace('www.', '');
    const warningText = " Redirecting to a third-party website, opens in a new tab.";
  
    $('a[href^="http://"], a[href^="https://"]').each(function() {
      const $link = $(this);
      const linkHost = this.hostname.replace('www.', '');
  
      if (linkHost === currentHost || !linkHost) return; // Skip internal links
  
      // Get text or fallback from image alt
      let linkText = $link.text().trim();
      if (!linkText) {
        const imgAlt = $link.find('img').attr('alt');
        linkText = imgAlt ? imgAlt.trim() : linkHost;
      }
  
      // Build aria-label
      const currentAriaLabel = $link.attr('aria-label');
      const newLabel = currentAriaLabel 
        ? `${currentAriaLabel}${warningText}` 
        : `${linkText}${warningText}`;
  
      // Apply attributes
      $link.attr({
        'aria-label': newLabel,
        'target': '_blank',
        'rel': 'noopener noreferrer nofollow'
      });
  
    });
});




// Gallery 
// $(document).ready(function () {

//   function updateGalleryAria() {
//       $('.product__media-list').each(function () {

//           const $slides = $(this).find('.product__media');
//           const $selectedSlide = $slides.filter('.selected');

//           $slides.each(function (index) {
//               const $slide = $(this);

//               // If a selected slide exists, use it.
//               // Otherwise treat the first slide as active.
//               const isActive = $selectedSlide.length
//                   ? $slide.hasClass('selected')
//                   : index === 0;

//               $slide.attr('aria-hidden', isActive ? 'false' : 'true');
//               $slide.attr('aria-current', isActive ? 'true' : 'false');

//               // $slide.find('a, button, input, select, textarea').each(function () {
//               //     $(this).attr('tabindex', isActive ? '0' : '-1');
//               // });
//           });
//       });
//   }

//   // Initial load
//   updateGalleryAria();

//   // Watch for selected class changes
//   const galleryObserver = new MutationObserver(function () {
//       updateGalleryAria();
//   });

//   $('.product__media-list').each(function () {
//       galleryObserver.observe(this, {
//           subtree: true,
//           attributes: true,
//           attributeFilter: ['class']
//       });
//   });

// });


//  Homepage tabs
$(document).ready(function () {

  function updateTabAriaSelected() {
      $('[role="tab"]').each(function () {
          $(this).attr('aria-selected', this.disabled ? 'true' : 'false');
      });
  }

  // Set initial state
  updateTabAriaSelected();

  // Watch for changes to the disabled attribute
  $('[role="tab"]').each(function () {
      const observer = new MutationObserver(function () {
          updateTabAriaSelected();
      });

      observer.observe(this, {
          attributes: true,
          attributeFilter: ['disabled']
      });
  });

});

// Header Language Tabs
$(document).ready(function () {
  $('.localization__item > button').on('click', function () {
    var $btn = $(this);
    var $wrapper = $btn.closest('.localization__item');

    setTimeout(function () {
      $btn.attr('aria-expanded', $wrapper.attr('aria-expanded'));
    }, 0);
  });
});

// Announcement Bar Accessibility Fix
$(document).ready(function ($) {

  const $slider = $('.announcement__slides');

  function fixAnnouncementAccessibility() {
    $slider.find('.announcement__slide').each(function () {
      const $slide = $(this);
      const $link = $slide.find('a');

      if ($slide.attr('aria-hidden') === 'true') {
        $link.attr('tabindex', '-1');
      } else {
        $link.removeAttr('tabindex');
      }
    });
  }

  fixAnnouncementAccessibility();

  $slider.on('change.flickity', function () {
    fixAnnouncementAccessibility();
  });

});

// Rental Form Focus
// $(document).ready(function () {
//   const modal = document.getElementById('rental-form-modal');

//   // Don't run if the modal doesn't exist on this page
//   if (!modal) return;

//   const closeBtn = document.getElementById('rental-form-close');
//   const modalContent = modal.querySelector('.rental-form-modal-content');
//   const triggerButtons = document.querySelectorAll('.rental-form-init');

//   let lastTriggerElement = null;

//   modalContent.setAttribute('tabindex', '-1');
//   modal.setAttribute('role', 'dialog');
//   modal.setAttribute('aria-modal', 'true');

//   closeBtn.setAttribute('tabindex', '0');
//   closeBtn.setAttribute('role', 'button');

//   function openModal(triggerEl) {
//     lastTriggerElement = triggerEl;

//     modal.style.display = 'flex';

//     requestAnimationFrame(() => {
//       closeBtn.focus();
//     });

//     document.addEventListener('keydown', onKeydown);
//   }

//   function closeModal() {
//     modal.style.display = 'none';
//     document.removeEventListener('keydown', onKeydown);

//     if (lastTriggerElement) {
//       lastTriggerElement.focus();
//       lastTriggerElement = null;
//     }
//   }

//   function onKeydown(e) {
//     if (e.key === 'Escape') {
//       closeModal();
//       return;
//     }

//     if (e.key === 'Tab') {
//       trapFocus(e);
//     }
//   }

//   function trapFocus(e) {
//     const focusable = modal.querySelectorAll(
//       'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
//     );

//     if (!focusable.length) return;

//     const first = focusable[0];
//     const last = focusable[focusable.length - 1];

//     if (e.shiftKey && document.activeElement === first) {
//       e.preventDefault();
//       last.focus();
//     } else if (!e.shiftKey && document.activeElement === last) {
//       e.preventDefault();
//       first.focus();
//     }
//   }

//   triggerButtons.forEach((btn) => {
//     btn.addEventListener('click', () => openModal(btn));
//   });

//   closeBtn.addEventListener('click', closeModal);

//   closeBtn.addEventListener('keydown', (e) => {
//     if (e.key === 'Enter' || e.key === ' ') {
//       e.preventDefault();
//       closeModal();
//     }
//   });

//   modal.addEventListener('click', (e) => {
//     if (e.target === modal) {
//       closeModal();
//     }
//   });
// });

// Click here links label
$(document).ready(function ($) {

  const currentHost = window.location.hostname.replace('www.', '');
  const warningText = "redirecting to a third-party website, opens in new tab.";

  $('a').each(function () {

    const $el = $(this);

    const text = $el.text().trim();
    if (!text) return;

    // Normalize text (handles click here. / click here!)
    const normalized = text
      .toLowerCase()
      .replace(/[.,!?;:]+$/, '')
      .trim();

    // Only target "click here"
    if (normalized === 'click here') {

      const href = $el.attr('href') || '';
      let context = '';
      let isExternal = false;

      try {
        const url = new URL(href, window.location.origin);

        // Check external link
        const linkHost = url.hostname.replace('www.', '');
        if (linkHost && linkHost !== currentHost) {
          isExternal = true;
        }

        // Build context from URL
        context = url.pathname
          .replace(/^\/(pages|products|collections|blogs|policies)\//, '') // remove Shopify prefixes
          .replace(/\/+/g, ' ')
          .replace(/-/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();

      } catch (e) {
        context = '';
      }

      // Build label
      let label = 'Click here';

      if (context) {
        label = `Click here to ${context}`;
      }

      // Add external warning
      if (isExternal) {
        label += `, ${warningText}`;
      }

      // Final cleanup
      label = label
        .replace(/\s+/g, ' ')
        .trim();

      // Set aria-label
      const existing = $el.attr('aria-label') || '';

      if (!existing || existing.toLowerCase() === 'click here') {
        $el.attr('aria-label', label);
      }

    }

  });

});